<div class="mt-1">
  <div class="grid">
    <div class="col-12">
      <input pInputText (keyup.enter)="DOInputEnter($event)" [style]="{ 'width': '100%' }" autofocus />
    </div>

    <div class="col-12" *ngIf="isNeedShowPicking">
      <button pButton pRipple icon="fas fa-box" pTooltip="{{selectedPickingText}}"
        (click)="selectedPicking($event)"
        [ngClass]="{
          'p-button-warning': selectedCheckBox == '1'
        }"></button>
    </div>

    <div class="col-12">
      <p-listbox [options]="importDOs" optionLabel="doNo" optionValue="doNo" [listStyle]="{'height':'15rem'}">
      </p-listbox>
    </div>
  </div>
  <div class="grid mt-2" style="text-align:center;">
    <div class="col text-center" style="text-align:center;">
      <button pRipple pButton label="{{ 'Common.Button.Confirm' | translate }}" (click)="confirmBtnClick($event)"></button>
      <button pRipple pButton label="{{ 'Common.Button.Clean' | translate }}" class="p-button-secondary ml-2"
        (click)="cleanBtnClick($event)"></button>
      <button pRipple pButton label="{{ 'Common.Button.DeleteDuplicate' | translate }}"
        class="p-button-secondary ml-2" (click)="distinctBtnClick($event)"></button>
    </div>
  </div>

</div>
